import store from '../store';

export const getRoutes = (routes) => {
  const { acl, activeBusiness } = store.state;
  const filteredRoutes = routes.filter((r) => {
    if (r.meta.requireAuth) {
      const hasAccess = r.meta.resources
        .map((resource) => Object.prototype.hasOwnProperty.call(acl, resource))
        .reduce((a, c) => a && c);

      return hasAccess;
    }

    return true;
  });
  let releaseGroup = filteredRoutes;
  if (![29, 170, 220].includes(activeBusiness.id)) {
    releaseGroup = filteredRoutes.filter((item) => !['/customers', '/virtual-account'].includes(item.path));
  }
  return releaseGroup;
};

export const checkAccess = (resources) => {
  const { acl } = store.state;
  const hasAccess = resources
    .map((resource) => Object.prototype.hasOwnProperty.call(acl, resource))
    .reduce((a, c) => a && c);

  return !!hasAccess;
};

export const checkPermission = (resource, permission) => {
  const { acl } = store.state;
  const isExist = Object.prototype.hasOwnProperty.call(acl, resource);
  // console.log(resource);
  // console.log(isExist);

  if (isExist) {
    const permissions = acl[resource];
    // console.log(permissions);
    const hasPermission = permissions.includes(permission);
    // console.log(hasPermission);

    return hasPermission;
  }
  return false;
};
